import { Modal, Button, Space, Row, Col, Input, Select } from "antd";

const AdvancePaymentModal = ({
  visible,
  onCancel,
  onSubmit,
  loading = false,
  amount,
  setAmount,
  paymentMethod,
  setPaymentMethod,
  PAYMENT_METHOD = [],
}) => {
  return (
    <Modal
      title="Advance Payment"
      open={visible} // ⚠️ use "open" (antd v5)
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={onSubmit}
          loading={loading}
        >
          Submit
        </Button>,
      ]}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <b>Amount:</b>
            <Input
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
              min={0}
            />
          </Col>

          <Col span={12}>
            <b>Payment Method:</b>
            <Select
              value={paymentMethod}
              onChange={setPaymentMethod}
              style={{ width: "100%" }}
              options={PAYMENT_METHOD.map((method) => ({
                ...method,
                disabled:
                  method.value === "razorpay" && parseFloat(amount || 0) <= 0,
              }))}
            />
          </Col>
        </Row>
      </Space>
    </Modal>
  );
};

export default AdvancePaymentModal;
